export default __webpack_public_path__ + "static/media/gift_shop.42c15f91.svg";